import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { LEARNER_ASSIGNMENT_COUNTS_QUERY_KEY, LEARNER_ASSIGNMENT_QUERY_KEY } from "./learnerAssignmentQueryKeys";

/**
 * Brings back what the API stores about the assignments: the status each one stands on, and how
 * many sit in each of them.
 *
 * Everything that moves an assignment along — declaring the start, handing work in — goes through
 * another resource, so nothing refreshes the lifecycle the learner reads unless it is asked to.
 */
export const useRefreshLearnerAssignments = () => {
    const queryClient = useQueryClient();

    return useCallback(
        () =>
            Promise.all([
                queryClient.invalidateQueries({ queryKey: [LEARNER_ASSIGNMENT_QUERY_KEY] }),
                queryClient.invalidateQueries({ queryKey: [LEARNER_ASSIGNMENT_COUNTS_QUERY_KEY] }),
            ]),
        [queryClient],
    );
};
